<div class="overlay" *ngIf="openSideMenu"></div>

<div class="flex items-center justify-between w-full h-[130px] px-10 bg-light-purple">
  <a class="logo flex items-center space-x-2" href="/home">
    <img class="w-[200px] lg:w-[150px] min-w-20" [src]="logoUrl" alt="Prism Logo">
  </a>
    <div *ngIf="!isSiteOffline" style="display: contents;">
      <prism-navbar
        class="prism-navbar"
        [ngClass]="{ 'mb-[20px] pl-[200px]': isLoggedIn }"
        [openSideMenu]="openSideMenu"
        (toggleSideMenu)="click()"
        (openLoginModal)="toggleModal(HeaderModalType.Login)"
        (closeSideMenu)="openSideMenu = false">
      </prism-navbar>

      <div *ngIf="isLoggedIn" class="relative text-left hidden lg:inline-block">
        <button
          class="flex items-center"
          aria-haspopup="true"
          [attr.aria-expanded]="isDropdownOpen"
          (click)="toggleDropdown()">
            <img [src]="iconImgUrl" alt="User Icon" class="mr-2" />
            <i class="uil uil-angle-down text-xl text-dark-purple"></i>
        </button>
        <div
          *ngIf="isDropdownOpen"
          #dropdownMenu
          class="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white"
          role="menu"
          tabindex="0"
          (keydown.enter)="closeDropdown()">
            <div class="px-4 py-2 text-sm text-gray-500" role="none">
              {{ currentUser()?.fullName }}
            </div>
            <div class="px-4 py-2 italic text-sm text-gray-500" role="none">
              {{ currentUser()?.roleName }}
            </div>
            <div *ngIf="currentUser()?.districtIds" class="px-4 py-2" role="none">
              {{ currentUser()?.districtName }}
            </div>
            <hr role="separator" />
            <div class="font-bold text-dark-gray">
              <a href="/account-settings" class="block px-4 py-2 text-sm" role="menuitem" tabindex="0" (keydown.enter)="router.navigate(['/account-settings'])">
                Account Settings
              </a>
              <hr role="separator" />
              <button (click)="logout()" class="block w-full text-left px-4 py-2 text-sm" role="menuitem" tabindex="0" (keydown.enter)="logout()">
                <i class="uil uil-signout text-lg text-dark-gray"></i> Log Out
              </button>
            </div>
        </div>
    </div>
  </div>

  <div *ngIf="!isSiteOffline" class="lg:hidden">
    <i *ngIf="!openSideMenu" class="text-4xl uil uil-bars cursor-pointer" (click)="click()"></i>
  </div>
</div>

<nz-modal *ngIf="!isSiteOffline" [(nzVisible)]="isLoginVisible" nzTitle="Log In" tabindex="0" (nzOnCancel)="handleCancel()" [nzFooter]="null" [nzBodyStyle]="{'padding':'24px 24px 10px'}">
  <ng-container *nzModalContent>
    <form [formGroup]="loginForm" class="grid gap-4" (ngSubmit)="submit()">
      <prism-input [control]="emailAddress" label="Email" placeHolder="Email address" [required]="true" [inputType]="InputType.Email"></prism-input>
      <prism-input [control]="password" label="Password" placeHolder="Password" [required]="true" [inputType]="InputType.Password"></prism-input>
      <hr class="-mx-6">
      <div class="flex items-center">
        <prism-btn [disabled]="!loginForm.valid">Log in</prism-btn>
        <p class="ml-4">
          <a
            role="button"
            tabindex="0"
            (click)="toggleModal(HeaderModalType.ForgotPw)"
            (keydown.enter)="toggleModal(HeaderModalType.ForgotPw)"
            (keydown.space)="toggleModal(HeaderModalType.ForgotPw)"
          >
            Forgot password?
          </a>
        </p>
      </div>
    </form>
  </ng-container>
</nz-modal>

<nz-modal *ngIf="!isSiteOffline" [(nzVisible)]="isForgotPwVisible" nzTitle="Forgot Password" (nzOnCancel)="handleCancel()">
  <ng-container *nzModalContent>
    <h1>Enter your email address to reset your password.</h1>
    <form [formGroup]="forgotPwForm" class="grid gap-4">
      <prism-input [control]="forgotPwEmailAddress" placeHolder="Email address" [inputType]="InputType.Email"></prism-input>
    </form>
  </ng-container>
  <div *nzModalFooter class="flex items-center">
    <prism-btn [disabled]="!forgotPwForm.valid || isProcessing" (click)="submitForgotPw()">Forgot Password</prism-btn>
  </div>
</nz-modal>

<nz-modal *ngIf="!isSiteOffline" [(nzVisible)]="successModal" nzTitle="Forgot Password" nzOkText="Ok" nzCancelText="Cancel" (nzOnCancel)="handleCancel()" [nzFooter]="null">
  <ng-container *nzModalContent>
    <h1>Please check your inbox shortly for an email to reset your password.
      If you do not receive an email in your inbox after approximately 10-15 minutes,
      check your spam/junk mail folder. Thank you.</h1>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="maintenanceModeModal" nzTitle="Maintenance Mode" (nzOnCancel)="handleCancel()" [nzFooter]="null">
  <ng-container *nzModalContent>
    <p>{{ maintenanceMessage }}</p>
  </ng-container>
  <div *nzModalFooter>
    <prism-btn (click)="handleCancel()">OK</prism-btn>
  </div>
</nz-modal>
